import React, { useEffect, useState, useCallback } from "react";
import API from "../../services/api.ts";
import MedicalDatasetItem from "./MedicalDatasetItem.jsx";
import MedicalDatasetSearch from "./MedicalDatasetSearch.jsx";
import BreadcrumbNav from "../navigation/BreadcrumbNav.jsx";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../navbar/Navbar.js";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const StudyDatasetList = () => {

    const params = useParams();
    const studyId = params.StudyId;
    const [studyDatasets, setStudyDatasets] = useState([]);
    const [datasets, setDatasets] = useState([]);
    const [selectedDatasetIds, setSelectedDatasetIds] = useState([]);
    const navigate = useNavigate();

    // store in localStorage
    useEffect(() => {
        if (studyId) {
        localStorage.setItem('studyId', studyId);
        }
    }, [studyId]);

    const fetchStudyDatasets = useCallback(async () => {
        try {
            const response = await API.get('/datasets/study/' + studyId + '/');
            setStudyDatasets(response.data);
            // print to console
            console.log("Fetched study datasets:", response.data);
        } catch (err) {
            console.error("Error fetching study datasets:", err);
            toast.error("Failed to fetch study datasets.");
        }
    }, [studyId]);

    useEffect(() => {
        fetchStudyDatasets();
    }, [fetchStudyDatasets]);

    const updateStudyDatasets = async () => {
        try {
            await API.post('/studies/' + studyId + '/add_datasets/', {
                dataset_ids: selectedDatasetIds,
            });
            toast.success("Datasets added to study successfully.");
            // Refresh the study datasets list
            fetchStudyDatasets();
        } catch (err) {
            console.error("Error updating study datasets:", err);
            toast.error("Failed to update study datasets.");
        }
    };

    const fetchDatasets = async () => {
        try {
            const response = await API.get('/datasets/');
            setDatasets(response.data);
        } catch (err) {
            console.error("Error fetching datasets:", err);
            toast.error("Failed to fetch datasets.");
        }
    }

    useEffect(() => {
        fetchDatasets();
    }, []);

    const updateSelectedDatasets = (datasetId, isSelected) => {
        if (isSelected) {
            setSelectedDatasetIds((prevIds) => [...prevIds, datasetId]);
        } else {
            setSelectedDatasetIds((prevIds) =>
                prevIds.filter((id) => id !== datasetId)
            );
        }
    };

    // Redirecting function to create a new dataset
    const redirectToCreateDataset = () => {
        navigate('/CreateDataset');
    };

    return (
        <div>
            {/* Header Navigation */}
            <Navbar />

            <hr />
            <BreadcrumbNav
                paths={["Dashboard", "Study/" + (studyId ? studyId : "No ID"), "StudyDatasets/" + (studyId ? studyId : "No ID")]}
            />
            <hr />

            <div className="container mt-4">
                <ToastContainer autoClose={3000} />
                <h2 className="text-center mb-4">Study Dataset Library</h2>

                <div className="border p-4 mb-5">
                    {studyDatasets.length > 0 ? (
                        <div className="col-md-12">
                            <table className="table table-striped mt-4">
                                <thead className="text-center">
                                    <tr>
                                        <th>Dataset</th>
                                        <th>Description</th>
                                        <th>Created At</th>
                                        <th># Samples</th>
                                        <th>Remove</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {studyDatasets.map((dataset) => (
                                        <tr key={dataset.id}>
                                            <td>{dataset.name}</td>
                                            <td>{dataset.description}</td>
                                            <td>{new Date(dataset.created_at).toLocaleDateString()}</td>
                                            <td>{dataset.sample_count}</td>
                                            <td>
                                                <button
                                                    className="btn btn-danger"
                                                    onClick={async () => {
                                                        try {
                                                            await API.post(`/studies/${studyId}/remove_dataset/`, {
                                                                dataset_id: dataset.id,
                                                            });
                                                            toast.success("Dataset removed from study successfully.");
                                                            fetchStudyDatasets();
                                                        } catch (err) {
                                                            console.error("Error removing dataset from study:", err);
                                                            toast.error("Failed to remove dataset from study.");
                                                        }
                                                    }}
                                                >
                                                    Remove
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="text-center mt-4">No datasets associated with this study.</p>
                    )}

                </div>

                <hr className="my-5" />

                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="text-center">Medical Dataset Library</h2>
                    <button className="btn btn-primary" onClick={redirectToCreateDataset}>Create Dataset</button>
                </div>

                {/* Medical Datasets Section */}
                <div className="border p-4">
                    <div className="col-md-12 mb-4 text-center">
                        <button type="submit" className="btn btn-success" onClick={updateStudyDatasets}>
                            Add Selected Datasets to Study
                        </button>
                    </div>

                    <MedicalDatasetSearch refreshMedicalDatasets={fetchDatasets} />

                    {datasets ? (
                        <table className="table table-striped mt-4">
                            <thead className="text-center">
                                <tr>
                                    <th>Select</th>
                                    <th>Dataset</th>
                                    <th>Description</th>
                                    <th>Created At</th>
                                    <th># Samples</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {datasets.map((dataset) => (
                                    <MedicalDatasetItem
                                        key={dataset.id}
                                        dataset={dataset}
                                        refreshSelectedDatasets={updateSelectedDatasets}
                                    />
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center mt-4">No datasets available.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StudyDatasetList;
